"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cart_1 = __importDefault(require("../helpers/cart"));
var log_1 = __importDefault(require("../helpers/log"));
var miniBasket_1 = __importDefault(require("./miniBasket"));
var currency_1 = __importDefault(require("../helpers/currency"));
var metred_1 = __importDefault(require("./metred"));
var AddToBag = /** @class */ (function () {
    function AddToBag() {
        this.config = {
            form: '[data-add-to-cart]',
            quantity: '[data-add-to-cart-quantity]',
            quantityPlus: '[data-add-to-cart-quantity-plus]',
            quantityMinus: '[data-add-to-cart-quantity-minus]',
            id: '[data-add-to-cart-id]',
            btn: '[data-add-to-cart-btn]',
            price: '[data-add-to-cart-price]',
            property: '[data-add-to-cart-property]',
            btnText: {
                addToBag: 'Add To Bag',
                noInventory: 'Out of Stock',
                noVariant: 'Unavailable'
            }
        };
    }
    AddToBag.prototype.init = function () {
        var forms = document.querySelectorAll(this.config.form);
        if (!forms.length)
            return;
        this.load(forms);
    };
    AddToBag.prototype.load = function (forms) {
        var _this = this;
        forms.forEach(function (form) {
            var quantityPlus = form.querySelector(_this.config.quantityPlus);
            var quantity = form.querySelector(_this.config.quantity);
            var quantityMinus = form.querySelector(_this.config.quantityMinus);
            form.addEventListener('submit', _this.submit.bind(_this, form));
            if (quantityPlus)
                quantityPlus.addEventListener('click', _this.quantityPlus.bind(_this, form));
            if (quantityMinus)
                quantityMinus.addEventListener('click', _this.quantityMinus.bind(_this, form));
            if (quantity)
                quantity.addEventListener('change', _this.quantityChange.bind(_this, form));
            if (quantityPlus && quantityMinus)
                _this.updateQuantityItems(form);
            if (form.dataset.disabled === '') {
                _this.enabled(false, form, {
                    id: 0,
                    available: false,
                    options: null
                });
            }
        });
    };
    AddToBag.prototype.quantityChange = function (form) {
        var quantity = form.querySelector(this.config.quantity);
        if (!quantity)
            return;
        var value = parseInt(quantity.value);
        quantity.value = value.toString();
        if (parseInt(quantity.value) > parseInt(quantity.max))
            quantity.value = quantity.max;
        if (parseInt(quantity.value) < parseInt(quantity.min))
            quantity.value = quantity.min;
        this.updateQuantityItems(form);
    };
    AddToBag.prototype.updateQuantityItems = function (form) {
        var quantity = form.querySelector(this.config.quantity);
        if (!quantity)
            return;
        this.quantityPlus(form);
        this.quantityMinus(form);
    };
    AddToBag.prototype.quantityPlus = function (form) {
        var quantity = form.querySelector(this.config.quantity);
        var plusIcon = form.querySelector(this.config.quantityPlus);
        var minusIcon = form.querySelector(this.config.quantityMinus);
        var value = parseInt(quantity.max) <= 1 ? 1 : parseInt(quantity.value) + 1;
        if (parseInt(quantity.max) > 1)
            plusIcon.classList.remove('disabled');
        if (parseInt(quantity.max) > 1)
            minusIcon.classList.remove('disabled');
        if (value <= parseInt(quantity.max))
            quantity.value = value.toString();
        if (parseInt(quantity.value) === parseInt(quantity.max) || parseInt(quantity.max) === 1) {
            plusIcon.classList.add('disabled');
        }
    };
    AddToBag.prototype.quantityMinus = function (form) {
        var quantity = form.querySelector(this.config.quantity);
        var minusIcon = form.querySelector(this.config.quantityMinus);
        var plusIcon = form.querySelector(this.config.quantityPlus);
        var value = parseInt(quantity.max) <= 1 ? 1 : parseInt(quantity.value) - 1;
        if (parseInt(quantity.max) > 1)
            plusIcon.classList.remove('disabled');
        if (parseInt(quantity.max) > 1)
            minusIcon.classList.remove('disabled');
        if (value >= parseInt(quantity.min))
            quantity.value = value.toString();
        if (parseInt(quantity.min) === parseInt(quantity.value)) {
            minusIcon.classList.add('disabled');
        }
    };
    AddToBag.prototype.quantity = function (form) {
        var quantity = form.querySelector(this.config.quantity);
        if (quantity && quantity.value)
            return parseInt(quantity.value);
        return 1;
    };
    AddToBag.prototype.id = function (form) {
        var id = form.querySelector(this.config.id);
        if (id && id.value)
            return parseInt(id.value);
        return;
    };
    AddToBag.prototype.enabled = function (enabled, form, variant) {
        var _this = this;
        form.querySelectorAll(this.config.btn).forEach(function (btn) {
            btn.disabled = !enabled;
            var btnTextNode = btn.querySelector('.btn-add-to-bag__text');
            btn.classList.remove('btn-add-to-bag--unavailable');
            if (document.querySelectorAll('div[data-metred-quantity]').length === 0) {
                btnTextNode.innerText = _this.updateBtnText(variant, enabled);
            }
            if (!variant || !enabled) {
                btn.classList.add('btn-add-to-bag--unavailable');
                btn.disabled = true;
            }
            if (!variant) {
                return;
            }
        });
    };
    AddToBag.prototype.updateBtnText = function (variant, enabled) {
        if (variant && !variant.available || !enabled)
            return this.config.btnText.noInventory;
        if (!variant)
            return this.config.btnText.noVariant;
        return this.config.btnText.addToBag;
    };
    AddToBag.prototype.updateVariant = function (form, variant) {
        var inputs = form.querySelectorAll(this.config.id);
        var prices = document.querySelectorAll(this.config.price);
        var quantity = document.querySelector(this.config.quantity);
        if (quantity) {
            quantity.max = variant.inventory_quantity === 0 ? 999 : variant.inventory_quantity;
            quantity.value = '1';
        }
        var value = null;
        if (variant) {
            value = String(variant.id);
            inputs.forEach(function (input) { return input.value = value; });
            prices.forEach(function (price) {
                var original_price = price.parentNode.querySelector('.product-prices__price--compare-at-price');
                if (original_price)
                    original_price.innerHTML = currency_1.default.format(variant.compare_at_price);
                if (price.dataset.productId) {
                    var elem = document.createElement('span');
                    elem.dataset.variantId = variant.id.toString();
                    elem.classList.add('product-prices__price');
                    elem.classList.add('money');
                    elem.dataset.addToCartPrice = '';
                    elem.innerText = currency_1.default.format(variant.price);
                    elem.dataset.productId = metred_1.default.config.products ? metred_1.default.config.products[0].data.id : price.dataset.productId;
                    price.parentNode.prepend(elem);
                    price.remove();
                }
                price.innerText = currency_1.default.format(variant.price);
            });
            this.updateQuantityItems(form);
        }
        else {
            this.enabled(false, form);
        }
    };
    AddToBag.prototype.enableBtnLoading = function (form) {
        form.querySelectorAll(this.config.btn).forEach(function (btn) {
            btn.disabled = true;
            btn.classList.add('btn-add-to-bag--loading');
        });
    };
    AddToBag.prototype.disableBtnLoading = function (form) {
        form.querySelectorAll(this.config.btn).forEach(function (btn) {
            btn.disabled = false;
            btn.classList.remove('btn-add-to-bag--loading');
        });
    };
    AddToBag.prototype.properties = function (form) {
        var properties = {};
        var propertyInputs = form.querySelectorAll(this.config.property);
        if (!propertyInputs.length)
            return properties;
        propertyInputs.forEach(function (property) {
            properties[property.dataset.addToCartProperty] = property.value;
        });
        return properties;
    };
    AddToBag.prototype.submit = function (form, event) {
        return __awaiter(this, void 0, void 0, function () {
            var quantity, id, properties, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.enableBtnLoading(form);
                        quantity = this.quantity(form);
                        id = this.id(form);
                        properties = this.properties(form);
                        if (!id || !quantity)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, cart_1.default.add({
                                items: [
                                    {
                                        quantity: this.quantity(form),
                                        id: this.id(form),
                                        properties: properties
                                    }
                                ]
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        log_1.default.error(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.disableBtnLoading(form);
                        miniBasket_1.default.update();
                        miniBasket_1.default.open(event);
                        return [2 /*return*/];
                }
            });
        });
    };
    return AddToBag;
}());
exports.default = new AddToBag();
